/**
 * 타임존 변환 유틸리티
 * UTC와 브라우저 로컬 타임존 간 변환 지원
 */

/**
 * UTC 시간을 브라우저 로컬 타임존으로 변환하여 datetime-local 형식 반환
 * @param {string|Date} utcDateTime - UTC 시간 문자열 또는 Date 객체
 * @returns {string} datetime-local 형식 문자열 (YYYY-MM-DDTHH:mm)
 */
export function utcToLocalDateTimeInput(utcDateTime) {
  if (!utcDateTime) return ''
  
  const localDate = new Date(utcDateTime)
  const offset = localDate.getTimezoneOffset() * 60000
  return new Date(localDate.getTime() - offset).toISOString().slice(0, 16)
}

/**
 * datetime-local 입력값을 UTC ISO 문자열로 변환
 * @param {string} localDateTime - datetime-local 형식 문자열 (YYYY-MM-DDTHH:mm)
 * @returns {string|null} UTC ISO 문자열 또는 null
 */
export function localDateTimeInputToUtc(localDateTime) {
  if (!localDateTime) return null
  
  return new Date(localDateTime).toISOString()
}

/**
 * UTC 시간을 브라우저 로컬 타임존으로 표시 (읽기 전용)
 * @param {string|Date} utcDateTime - UTC 시간 문자열 또는 Date 객체
 * @param {Object} options - Intl.DateTimeFormat 옵션
 * @returns {string} 로컬 타임존 표시 문자열
 */
export function formatLocalDateTime(utcDateTime, options = {}) {
  if (!utcDateTime) return ''
  
  const defaultOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }
  
  return new Date(utcDateTime).toLocaleString('ko-KR', { ...defaultOptions, ...options })
}